import { CYLINDER_POSITION, TEST_STATE } from '@locales/id/cylinders';
import { fillInfo, isWarehouse } from '@locales/id/labels';
import { POSITION_TONE, WAREHOUSE_TONE } from '@constants/tones';
import type { Cylinder, CylinderStatus, TestState } from '@lib/api';
import { Chip } from '@ui';

/**
 * Where it is, in this page's words: Di Titik Distribusi (green), Di gudang (grey), Dalam pengiriman, Tidak ditemukan,
 * Di warga.
 */
export function PositionBadge({ c }: { c: Pick<Cylinder, 'positionStatus' | 'locationType'> }) {
  const home = c.positionStatus === 'AT_LOCATION' && isWarehouse(c.locationType);
  return <Chip tone={home ? WAREHOUSE_TONE : POSITION_TONE[c.positionStatus]}>{home ? CYLINDER_POSITION.warehouse : CYLINDER_POSITION[c.positionStatus]}</Chip>;
}

/**
 * What it holds (Isi green, Kosong neutral), for a cylinder in service: a destroyed one, or a backend that does not
 * say, shows nothing.
 */
export function FillBadge({ c }: { c: Pick<Cylinder, 'fillState' | 'status'> }) {
  if (!c.fillState || c.status === 'DESTROYED') return null;
  const f = fillInfo(c.fillState);
  return <Chip tone={f.tone}>{f.label}</Chip>;
}

/** The retest only when it needs a look: due within 30 days (amber), past (red). */
export function TestBadge({ state, status }: { state: TestState; /** a destroyed cylinder has no retest to keep */ status?: CylinderStatus }) {
  if (status === 'DESTROYED' || (state !== 'soon' && state !== 'overdue')) return null;
  return <Chip tone={state === 'overdue' ? 'critical' : 'amber'}>{TEST_STATE[state]}</Chip>;
}
